export const MIN_WIDTH = 16;
export const MIN_HEIGHT = 16;
